import { render, staticRenderFns } from "./BulletPointsWidget.vue?vue&type=template&id=15edcdfb&"
import script from "./BulletPointsWidget.vue?vue&type=script&lang=js&"
export * from "./BulletPointsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitHub\\bulletPointWidget\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15edcdfb')) {
      api.createRecord('15edcdfb', component.options)
    } else {
      api.reload('15edcdfb', component.options)
    }
    module.hot.accept("./BulletPointsWidget.vue?vue&type=template&id=15edcdfb&", function () {
      api.rerender('15edcdfb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/BulletPointsWidget.vue"
export default component.exports